import React, { useState } from 'react';
import YearDropdown from '../../DateSelectors/YearDropdown';
import MonthDropdown from '../../DateSelectors/MonthDropdown';
import FormInput from '../../Forms/FormInput';

import { validate } from '../../validate';
import InstitutionMenu from './InstitutionMenu/InstitutionMenu';
import { IBLSpinLoader } from '../../../IBLSpinLoader';
import { createEducation, deleteEducation, updateEducation } from '../../helpers';
import { useInstitutionMenu } from '../../../../hooks/useInstitutionMenu';
/*import _default from 'chart.js/dist/plugins/plugin.tooltip';
import numbers = _default.defaults.animations.numbers;*/

const EducationMenu = ({ setShowEducationMenu, handleSuccess, menuTitle, educationData, setEducationData, isUpdate = false}) => {

  const requiredFields = [
    'degree',
    'field_of_study',
    'location',
    'start_date',
    'start_year',
    'description'
  ];

    const [showInstitutionMenu, setShowInstitutionMenu] = useState(false);


    const hideInstitutionMenu = () => {
      setShowInstitutionMenu(false);
    }



  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});


const {institutions, setInstitutions} = useInstitutionMenu(isUpdate, educationData, setEducationData, setIsLoading);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEducationData({ ...educationData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };



  const handleResponse = (data) => {
    if (data.success) {
      setIsLoading(false);
      window.alert('Operation successful');
      handleSuccess();
    }
    else {
      setIsLoading(false);
      window.alert('Something went wrong, Please try again later');
      setShowEducationMenu(false);
    }
  }


  const deleteEducationInstance = (id) => {
    setIsLoading(true);
    deleteEducation(id, handleResponse);
  }





  
  const handleSave = () => {
    const newErrors = validate(educationData, requiredFields);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (educationData.institution_id === 0) {
      setErrors({ institution_id: "please create an institution first" });
      return;
    }
    if(educationData.grade){
      if (parseFloat(educationData.grade) > 4.0) {
        setErrors({ grade: "please use the 4.0 GPA scale" });
        return;
      } else if (isNaN(parseFloat(educationData.grade))) {
        setErrors({ grade: "grade must be a number" });
        return;
      }
    }


    // Format the dates
    const formatDate = (year, date) =>
      `${year}-${new Date(Date.parse(date + ' 1, 2012')).getMonth() + 1}-01`;

    const start_date = formatDate(educationData.start_year, educationData.start_date);
    const end_date = formatDate(educationData.end_year, educationData.end_date);


    if (!educationData.is_current) {
      // Validate the start and end date
      if (new Date(start_date) > new Date(end_date)) {
        setErrors({ end_date: "the end date cannot be before the start date." });

        return;
      }
    }

    const formData = {
      ...educationData,
      start_date: start_date,
      end_date: end_date,
    };


    // Remove start_year and end_year from the form data
    delete formData.start_year;
    if (educationData.is_current) {
      formData.end_date = null;
    }
    delete formData.end_year;


    setIsLoading(true);
    if (isUpdate) {
      updateEducation(formData, handleResponse);
      
    }
    else {
      createEducation(formData, handleResponse);
    }

   
  };

 

  return (
    <>
      <div
        data-name="followers"
        className="edit_profile_pop add-education-pop hidden active"
        style={{ display: showInstitutionMenu ? 'none' : 'block' }}
      >
        <div className="div-block-520">
          <div className="text-block-386">{menuTitle}</div>
          <div
            className="cancel_edit_profile w-embed"
            onClick={() => setShowEducationMenu(false)}
          ></div>
        </div>

        {isLoading ? (
          <IBLSpinLoader size={40} containerHeight={'200px'} />
        ) : (
          <>
            <div className="div-block-525">
              <div className="div-block-469 sk_s form_div">
                <div className="form_row">
                  <div className="text-block-297">Degree</div>
                  <div className="form-block-15 s_skill w-form">
                    <FormInput
                      name="degree"
                      placeholder="E.g Bachelor of Science"
                      value={educationData.degree}
                      onChange={handleInputChange}
                    />
                  </div>
                  {   "degree" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.degree as string}
                    </div>
                  )}
                </div>

                <div className="form_row">
                  <div className="text-block-297">Field of study</div>
                  <div className="form-block-15 s_skill w-form">
                    <select
                      id="field_of_study"
                      name="field_of_study"
                      className="select-field-3 w-select"
                      value={educationData.field_of_study}
                      onChange={handleInputChange}
                    >
                        <option value="Computer Science">Computer Science</option>
                        <option value="Law">Law</option>
                        <option value="Medicine">Medicine</option>
                        <option value="Engineering">Engineering</option>
                        <option value="Business Administration">Business Administration</option>
                        <option value="Psychology">Psychology</option>
                        <option value="Biology">Biology</option>
                        <option value="Physics">Physics</option>
                        <option value="Chemistry">Chemistry</option>
                        <option value="Mathematics">Mathematics</option>
                        <option value="Economics">Economics</option>
                        <option value="Sociology">Sociology</option>
                        <option value="Political Science">Political Science</option>
                        <option value="Education">Education</option>
                        <option value="History">History</option>
                        <option value="Philosophy">Philosophy</option>
                        <option value="Environmental Science">Environmental Science</option>
                        <option value="Art and Design">Art and Design</option>
                        <option value="Literature">Literature</option>
                        <option value="Anthropology">Anthropology</option>
                        <option value="Other">Other</option>

                    </select>
                  </div>
                  {  "field_of_study" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.field_of_study as string}
                    </div>
                  )}
                </div>

                <div className="form_row">
                  <div className="text-block-297">Institution</div>
                  <div className="form-block-15 s_skill w-form">
                    {!isLoading && ( 

                        <select
                          id="institution_id"
                          name="institution_id"
                          className="select-field-3 w-select"
                          value={educationData.institution_id}
                          onChange={handleInputChange}
                        >
                          {institutions.length > 0 ? (
                            institutions.map((institution) => (
                              <option key={institution.id} value={institution.id}>
                                {institution.name}
                              </option>
                            ))
                          ) : (
                            <option value="0">Create Institution</option>
                          )}

                        </select>
                    ) }
                  
                  </div>
                  { "institution_id" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.institution_id as string  }
                    </div>
                  )}
                  <a
                    data-w-id="8d07cdca-473b-6794-cdfc-2c33d3b803da"
                    href="#"
                    onClick={() => setShowInstitutionMenu(true)}
                    className="link-block-35 w-inline-block"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66f2b9df760bcd7636eacf9a_plus.svg"
                      loading="lazy"
                      alt=""
                      className="image-234"
                    />
                    <h5 className="heading-13">Add new institution</h5>
                  </a>
                </div>

                <div className="form_row">
                  <div className="text-block-297">Location</div>
                  <div className="form-block-15 s_skill w-form">
                    <FormInput
                      name="location"
                      placeholder="E.g San Francisco, CA"
                      value={educationData.location}
                      onChange={handleInputChange}
                    />
                  </div>
                  { "location" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.location as string  }
                    </div>
                  )}
                </div>

                <div className="form_row">
                  <div className="w-layout-hflex flex-block-55">
                    <div className="text-block-297 no-margin">Start date</div>
                    <div className="w-layout-hflex flex-block-56">
                      <div className="html-embed-26 w-embed">
                        <label className="mini-switch">
                          <input
                            type="checkbox"
                            name="is_current"
                            checked={educationData.is_current}
                            onChange={() =>
                              setEducationData((prevState) => ({
                                ...prevState,
                                is_current: !prevState.is_current,
                              }))
                            }
                          />
                          <span className="mini-switch-slider round" />
                        </label>
                      </div>
                      <h5 className="heading-14">Current</h5>
                    </div>
                  </div>
                  <div className="form-block-15 s_skill w-form">
                    <div className="w-layout-hflex flex-block-57">
                      <MonthDropdown
                          selectedMonth={isUpdate ? educationData?.start_month : null}
                        handleInputChange={handleInputChange}
                        name="start_date"
                        errors={ "start_date" in errors ? errors.start_date : null}
                      />
                      <YearDropdown
                        selectedYear={isUpdate ? educationData?.start_year : null}
                        handleInputChange={handleInputChange}
                        name="start_year"
                        errors={ "start_year" in errors ? errors.start_year : null}
                      />
                    </div>
                  </div>
                </div>

                {!educationData.is_current && (
                  <div className="form_row position-end-date-row">
                    <div className="w-layout-hflex flex-block-55">
                      <div className="text-block-297 no-margin">End date</div>
                    </div>
                    <div className="form-block-15 s_skill w-form">
                      <div className="w-layout-hflex flex-block-57">
                        <MonthDropdown
                          selectedMonth={isUpdate ? educationData?.end_month : null}
                          handleInputChange={handleInputChange}
                          name="end_date"
                          errors={ "end_date" in errors ? errors.end_date : null}
                        />
                        <YearDropdown
                          selectedYear={isUpdate ? educationData?.end_year : null}
                          handleInputChange={handleInputChange}
                          name="end_year"
                          errors={ "end_year" in errors ? errors.end_year : null}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="form_row">
                  <div className="text-block-297">Grade</div>
                  <div className="form-block-15 s_skill w-form">
                    <FormInput
                      name="grade"
                      placeholder="4.0 GPA Scale"
                      value={educationData.grade}
                      onChange={handleInputChange}
                      type={"number"}
                    />
                  </div>
                  { "grade" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.grade as string }
                    </div>
                  )}
                </div>

                <div className="form_row">
                  <div className="text-block-297">Activities</div>
                  <div className="form-block-15 s_skill w-form">
                    <textarea
                      placeholder="Add some activities"
                      maxLength={5000}
                      name="activities"
                      className="textarea-6 w-input"
                      value={educationData.activities}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="form_row">
                  <div className="text-block-297">Description</div>
                  <div className="form-block-15 s_skill w-form">
                    <textarea
                      placeholder="Add some description"
                      maxLength={5000}
                      name="description"
                      className="textarea-6 w-input"
                      value={educationData.description}
                      onChange={handleInputChange}
                    />
                  </div>
                  { "description" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.description as string }
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="popup-f add_content">
              <div
                className="div-block-475 cancel_edit_prof"
                onClick={() => setShowEducationMenu(false)}
              >
                <div className="text-block-284 cancel_dc">Cancel</div>
              </div>

                {isUpdate && (
                  <>
                    <div className="div-block-475 delete-skills" style={{width: '140px'}}
                      onClick={() => deleteEducationInstance(educationData.id)}
                    ><div className="text-block-284 add_skill_text cancel delete-s">Delete Education</div></div>
                  </>
                )}

              <div
                className="div-block-475 save_profile_info"
                onClick={handleSave}
              >
                <div className="text-block-284 add_skill_text">Save</div>
              </div>
            </div>
          </>
        )}
      </div>
      {showInstitutionMenu && <InstitutionMenu hideInstitutionMenu={hideInstitutionMenu} setInstitutions={setInstitutions} setEducationData={setEducationData} />}
    </>
  );
};

export default EducationMenu;
